// projects/humanresources-personnel/src/assets/i18n/*/hr-per-special-situation.json
export class HrPerSpecialSituationKey {
    private static readonly keyPrefix = 'hrPerSpecialSituation';
    public static title = `${HrPerSpecialSituationKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerSpecialSituationKey.keyPrefix}.pageHeader`;
    public static limbId = `${HrPerSpecialSituationKey.keyPrefix}.limbId`;
    public static typeId = `${HrPerSpecialSituationKey.keyPrefix}.typeId`;
    public static degreeId = `${HrPerSpecialSituationKey.keyPrefix}.degreeId`;
    public static enumLimbRightLeft = `${HrPerSpecialSituationKey.keyPrefix}.enumLimbRightLeft`;
    public static limbRightLeft = `${HrPerSpecialSituationKey.keyPrefix}.limbRightLeft`;
}
